module.exports = __webpack_public_path__ + "static/img/bpd_mobile.06b1ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/payment/bpd_mobile.png
// module id = 4Bm2
// module chunks = 1